export default {"src":"/_next/static/media/HST.5bb01310.svg","height":18,"width":18};